/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Skip_PrivateInputs */

const cs_settings_calendar_skip_private = /** @type {(inputs: Settings_Calendar_Skip_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočit soukromé příchozí události`)
};

const en_settings_calendar_skip_private = /** @type {(inputs: Settings_Calendar_Skip_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip private inbound events`)
};

/**
* | output |
* | --- |
* | "Skip private inbound events" |
*
* @param {Settings_Calendar_Skip_PrivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_skip_private = /** @type {((inputs?: Settings_Calendar_Skip_PrivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Skip_PrivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_skip_private(inputs)
	return cs_settings_calendar_skip_private(inputs)
});